import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EIPDatePickerComponent } from 'eipdate-picker';
import { CommonService } from 'src/app/Service/Common.service';
import { FinaDrawingReportService } from 'src/app/Service/fina-drawing-report.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { finalDrawingList } from 'src/app/ViewModel/Tender-Quantity.Model';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import { FileUploadLibrary } from 'src/app/Service/file/file.service';

@Component({
  selector: 'app-final-drawing',
  templateUrl: './final-drawing.component.html',
  styleUrls: ['./final-drawing.component.css']
})
export class FinalDrawingComponent implements OnInit {
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public isCLient!: boolean;
  public enableFilter = false;
  public obj: any;
  public enableFullscreen: boolean = false;
  public projectElements: IProjectElementsOutput[] = [];
  public finalDrawingList: finalDrawingList[] = [];
  DCI_Type!: FormGroup;
  numElements: Map<string, string> = new Map<string, string>();

  @ViewChild('todatePicker') dateRange!: EIPDatePickerComponent;
  is_Show_Attachment_In_DTN!: boolean;
  ShowSearch: boolean = false;

  constructor(private _projInfoService: ProjectInfoService, private _formBuilder: FormBuilder,
    private _commonService: CommonService, private dialog: MatDialog, private finaDrawingReportService: FinaDrawingReportService, private _WorkflowTemplateService: WorkflowTemplateService) {
    this.allData = this.allData.bind(this);
  }

  receviewData(data: any) {
    this.finalView(data);
  }

  ngOnInit() {
    this.obj = "final_drawing";
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.callMemberRoleandFeature();

    this.finalView({
      "project_Id": this.projectId,
      "group_Id": this.groupId,
      "from_Date": null,
      "to_Date": null,
      "stages": null,
      "schedule_Type": null,
      "drg_Type": null,
      "disc_Id": null,
      "struct_Id": null,
      "Dynamic_Id": []
    });

  }

  toggleShowSearch() {
    this.ShowSearch = !this.ShowSearch;
  }

  async callMemberRoleandFeature() {
    this._commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => {
      result = result.filter(data => data.role_Desc != 'Client');
      if (result.length > 0) {
        this.isCLient = false;
      }
      else {
        this.isCLient = true;
      }
    });
  }

  openAttachmentFileList(dataItem: any, fileUploadLibrary: number) {

    this._WorkflowTemplateService.getWorkflowTemplate(dataItem.workflow_Id).subscribe((data: WorkflowTemplateDialogModel) => {
      if (data && data.workflowStatus) {
        let _task_ID!: string;
        if (data.workflowStatus.some(x => x.is_Show_Attachment_In_DTN == true)) {
          fileUploadLibrary = FileUploadLibrary.WorkflowDocument;
          _task_ID = data.workflowStatus.filter(x => x.is_Show_Attachment_In_DTN == true).map(y => y.task_Id).join();
        }

        let obj = {
          "projectId": this.projectId,
          "docId": dataItem.doc_Id,
          "revisionNo": dataItem.revision_No,
          "libraryName": fileUploadLibrary,
          "documentNo": dataItem.doc_No,
          "createdBy": this.memberId,
          "isDeleteEnable": false,
          "task_ID": _task_ID
        }
        let dialogRef = this.dialog.open(FileListComponent, {
          panelClass: 'mat-dialog-secondary',
          width: '70%',
          maxWidth: '70vw',
          data: obj
        });
        dialogRef.afterClosed().subscribe(() => {
        });
      }
    });
  }

  finalView(obj?: any) {
    this.finaDrawingReportService.getFinalDrawingList(obj).subscribe(data => {
      this.finalDrawingList = data;
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.finalDrawingList
    };
    return result;
  }

  public toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
}